<template>
    <section class="app-main">
        <transition mode="out-in" name="fade">
            <router-view></router-view>
        </transition>
    </section>
</template>

<script>
export default {
    name: "AppMain",
    computed: {},
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue